import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBus"><Path d="M7.5 20.5H3.5V3.5H20.5V20.5H16.5V18.5H7.5V20.5Z" stroke="currentColor"/><Path d="M4 12.5H20" stroke="currentColor"/><Path d="M6 15.5H9" stroke="currentColor"/><Path d="M15 15.5H18" stroke="currentColor"/><Path d="M1 7.5L3.5 7.5" stroke="currentColor"/><Path d="M20.5 7.5L23 7.5" stroke="currentColor"/><Path d="M9 5.5H15" stroke="currentColor"/></CentralIconBase>;
});

export default IconBus;
